// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2274 ? "152ccbd5" : chunkId) + "." + {"2274":"6803c7ff9f5034c6","4713":"461855adf4575d74"}[chunkId] + ".js";
};